export default __webpack_public_path__ + "static/media/thinking-spinner.7705dcad.svg";